import { PostponeMatch as PostponeMatchComponent } from './PostponeMatch.component';
import { connector } from './PostponeMatch.connector';

export const PostponeMatch = connector(PostponeMatchComponent);
